import { inject, Injectable, signal } from '@angular/core';
import { BookmarkDBRecord } from 'src/app/interfaces/bookmark-db-record';
import { BookmarksProviderService } from 'src/app/providers/bookmarks/bookmarks.provider.service';
import { LoadingService } from 'src/app/services/loading/loading.service';

@Injectable({
  providedIn: 'root'
})
export class BookmarksService {
  private bookmarksProvider = inject(BookmarksProviderService);
  private loadingService = inject(LoadingService);

  bookmarks = signal<BookmarkDBRecord[]>([]);
  skusToCompare = signal<string[]>([]);
  selectedBookmarkIndex = signal<string | null>(null, { equal: () => false });


  constructor() {
    this.loadingService.load('BookmarksService::InitialLoad');
    this.get().then(bookmarks => {
      this.bookmarks.set(bookmarks ?? [])
      this.loadingService.done('BookmarksService::InitialLoad');
    });
  }

  async remove(sku: string) {
    this.selectedBookmarkIndex.set(null);
    await this.bookmarksProvider.remove(sku);
    const bookmarks = await this.get();
    this.bookmarks.set(bookmarks ?? []);
  }

  async add(sku: string, imageData: string) {
    this.selectedBookmarkIndex.set(null);
    await this.bookmarksProvider.add(sku, imageData);
    const bookmarks = await this.get();
    this.bookmarks.set(bookmarks ?? []);
  }

  async get() {
    const bookmarks = await this.bookmarksProvider.get();
    return bookmarks?.reverse();
  }

  async clear() {
    this.selectedBookmarkIndex.set(null);
    await this.bookmarksProvider.clear();
    this.bookmarks.set([]);
  }

  select(index: number) {
    this.selectedBookmarkIndex.set(this.skusToCompare()[index]);
  }
}
